import { AxiosResponse } from "axios";

import { SurveyBlocks } from "modules/MainSurveyEditor/surveyBlocks";
import { camelizeObject, snakizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import { PaginatedResults } from "types/Query";

const getSurveyBlocks = (
  parentSurveyId: number | string
): Promise<AxiosResponse<PaginatedResults<SurveyBlocks.Block>>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<PaginatedResults<SurveyBlocks.BlockApi>>) => {
    return {
      ...data,
      data: {
        ...data.data,
        results: data.data.results.map(camelizeObject<SurveyBlocks.Block>),
      },
    };
  });
};

const getSurveyBlock = (
  parentSurveyId: number | string,
  id: number | string
): Promise<AxiosResponse<SurveyBlocks.Block>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/${id}/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<SurveyBlocks.BlockApi>) => {
    return camelizeObject(data);
  });
};

const createSurveyBlock = (
  parentSurveyId: number | string,
  params: Partial<SurveyBlocks.Block>
): Promise<AxiosResponse<SurveyBlocks.Block>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/`,
      method: "POST",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<SurveyBlocks.BlockApi>) => {
    return camelizeObject(data);
  });
};

const updateSurveyBlock = (
  parentSurveyId: number | string,
  id: number | string,
  params: Partial<SurveyBlocks.Block>
): Promise<SurveyBlocks.Block> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/${id}/`,
      method: "PATCH",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<SurveyBlocks.BlockApi>) => {
    return camelizeObject(data.data);
  });
};

const deleteSurveyBlock = (parentSurveyId: number | string, id: number | string) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/${id}/`,
      method: "DELETE",
    },
  });
};

export const mainSurveyClient = {
  getSurveyBlocks,
  getSurveyBlock,
  createSurveyBlock,
  updateSurveyBlock,
  deleteSurveyBlock,
};
